import React from "react";

export const SaasContext = React.createContext<{
    tenantUpdate:string
} | null>(null);
